/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
  GetApiV1IndividualpaymentSharedPaymentTypesQueryParams,
  GetApiV1IndividualpaymentSharedPaymentTypes401,
  GetApiV1IndividualpaymentSharedPaymentTypes500,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedPaymentTypes.ts";

function getGetApiV1IndividualpaymentSharedPaymentTypesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/shared/payment-types` as const,
  };
  return res;
}

/**
 * @description Retorna apenas Billet, BilletPecegePay, CreditCardMundiPagg e CreditCardPecegePay, sem descrições repetidas. Migrado do legado EnumAsync/EPaymentType (projeção filtrada de EPaymentMethod). **(Requer Authorization para autenticação)**
 * @summary Dropdown de métodos de pagamento do pagamento individual (boleto e cartão) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/shared/payment-types}
 */
export async function getApiV1IndividualpaymentSharedPaymentTypes(
  params?: GetApiV1IndividualpaymentSharedPaymentTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedPaymentTypes401
      | GetApiV1IndividualpaymentSharedPaymentTypes500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentSharedPaymentTypesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
